import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { ISystemSetting } from 'types/systemSettings'

export const systemSettingsApi = createApi({
  reducerPath: 'systemSettings',
  baseQuery,
  endpoints: (builder) => ({

    systemSettings: builder.query<ISystemSetting[], void>({
      query: () => ({
        url: '/system-settings',
      }),
    }),

    systemSetting: builder.query<ISystemSetting, IdParams>({
      query: ({ id }) => `/system-settings/${id}`,
    }),

    createSystemSetting: builder.mutation<ISystemSetting, Partial<ISystemSetting>>({
      query: (body) => ({
        url: '/system-settings',
        body,
        method: 'post',
      }),
    }),

    updateSystemSetting: builder.mutation<ISystemSetting, Partial<ISystemSetting>>({
      query: (body) => ({
        url: `/system-settings/${body.id}`,
        body,
        method: 'put',
      }),
    }),
    
    deleteSystemSetting: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/system-settings/${id}`,
        method: 'delete',
      }),
    }),
  }),
})

export const {
  useSystemSettingQuery,
  useSystemSettingsQuery,
  useCreateSystemSettingMutation,
  useUpdateSystemSettingMutation,
  useDeleteSystemSettingMutation,
} = systemSettingsApi
